import { OrganizationKeyName } from "../../../model/Organization";
import { TimeslotTemplateUpdate } from "../model/TimeslotTemplatesSuccessResponse";

export const UPDATE_SHOP_TIMESLOT = "SHOP:UPDATE_TIMESLOT";

export const updateShopTimeslotAction = (
  organization: OrganizationKeyName,
  shopId: string,
  template: TimeslotTemplateUpdate
) => ({
  type: UPDATE_SHOP_TIMESLOT as typeof UPDATE_SHOP_TIMESLOT,
  shopId,
  organization,
  template,
});

export type UpdateShopTimeslotAction = ReturnType<
  typeof updateShopTimeslotAction
>;
